import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import _ from 'underscore';

import DatabaseService from 'services/DatabaseService.js';
import Utils from 'utils/Utils.js';
import {SET_LOADING_OVERLAY_ENABLE} from 'actions/types';

import {Tab, Button, Modal, Header, Input, Label, Message, Dropdown, Popup, Icon} from 'semantic-ui-react';
import {colors, fontSizes, spacings, shadow, buttons} from 'style';
import ChoosePhotoContainer from 'modules/misc/ChoosePhotoContainer.js';
import styleDef from './style.js';
import DeletePromptContainer from 'modules/misc/DeletePromptContainer.js'

const languages = [
    {key:'en',  text:'English',  value:'en'},
    {key:'fr',  text:'Français', value:'fr'},
];

const categories = [
    {key:'Raffle',  text:'Raffle',  value:'Raffle'},
    {key:'Points',  text:'Points', value:'Points'},
    {key:'Offer',  text:'Offer', value:'Offer'},
    {key:'Charity',  text:'Charity',  value:'Charity'},
    {key:'Gift Card',  text:'Gift Card', value:'Gift Card'},
    {key:'e-Resource',  text:'e-Resource', value:'e-Resource'},
]

const emptyLocale = () => ({
    title: '',
    description: '',
    brand: '',
    offer: '',
    template: '',
    terms: '',
    termsUrl: '',
});

var style = {
    ...styleDef,
    saveButton: {
        ...buttons.short,
        marginLeft: spacings.small,
        marginRight: spacings.small,
    },
    updateButton: {
        ...buttons.short,
        float: 'right',
        marginLeft: spacings.small,
        marginRight: spacings.small,
    },
    deleteButton: {
        ...buttons.short,
        marginLeft: spacings.small,
        marginRight: spacings.small,
        color: colors.warningRed,
        backgroundColor: '#fff',
    },
    uploadButton: {
        ...buttons.short,
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
    },
    photoSection: {
        width: '200px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    imagePreview: {
        display: 'block',
        boxShadow: shadow,
        borderRadius: '9px',
        width: '200px',
        height: '200px',
        objectFit: 'contain',
        margin: spacings.small,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    descriptionTextarea: {
        resize: 'vertical',
        height: '200px',
        width: '100%',
        borderRadius: '4px',
        border: '1px solid rgba(34, 36, 38, 0.15)',
    },
    termsTextarea: {
        resize: 'vertical',
        height: '100px',
        width: '100%',
        borderRadius: '4px',
        border: '1px solid rgba(34, 36, 38, 0.15)',
    },
    columns: {
    },
    column: {
        display: 'inline-block',
        width: '50%',
    },
    star: {
        color:colors.themeBlue,
        position: 'relative',
        top: '2px',
    },
    charactersLeftDesc: {
        float : 'right',
        marginBottom: '10px'
    },
    localeGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: spacings.small,
        columnGap: spacings.base * 1.5,
    },
    localeFieldFull: {
        gridColumn: '1 / -1',
    },
    localeLabel: {
        display: 'block',
        marginBottom: spacings.micro,
    },
    modalActions: {
        overflow: 'auto',
        marginTop: spacings.small,
    },
};

const LocaleField = ({label, labelInfo, required, children}) => (
    <div>
        <label style={style.localeLabel}>
            {labelInfo ? <>{required ? `${label}*` : label}&nbsp;</> : (required ? `${label}*` : label)}
            {labelInfo && (
                <Popup
                    trigger={<Icon name='question circle outline' />}
                    content={labelInfo}
                    position='right center'
                />
            )}
        </label>
        {children}
    </div>
);

const RewardLocalePane = ({t, data, valueChange, onChange, update, isMaster, brandKey, sku, onChangeBrandKey, onChangeSku}) => (
    <div>
    <br />
    <div style={style.localeGrid}>
        <LocaleField label={t('brand_prompt')}>
            <Popup trigger={
                <Input fluid value={data ? data.brand : ''}
                    name='brand'
                    onChange={onChange}
                    onFocus={onChange}
                    maxLength='200' />
            }
                position='right center'
                content={(200 - valueChange) + ' characters left'}
                on='focus' />
        </LocaleField>
        <LocaleField label={t('offer_label')} labelInfo={t('offer_prompt_help')}>
            <Popup trigger={
                <Input fluid value={data ? data.offer : ''}
                    name='offer'
                    onChange={onChange}
                    onFocus={onChange}
                    maxLength='50' />
            }
                position='right center'
                content={(50 - valueChange) + ' characters left'}
                on='focus' />
        </LocaleField>
        <LocaleField label={t('title_prompt')} required>
            <Popup trigger={
                <Input fluid value={data ? data.title : ''}
                    name='title'
                    onChange={onChange}
                    onFocus={onChange}
                    maxLength='50' />
            }
                position='right center'
                content={(50 - valueChange) + ' characters left'}
                on='focus' />
        </LocaleField>
        {isMaster &&
            <LocaleField label={t('template_prompt')}>
                <Popup trigger={
                    <Input fluid value={data ? data.template : ''}
                        name='template'
                        placeholder={t('template_placeholder')}
                        onChange={onChange}
                        onFocus={onChange}
                        maxLength='50' />
                }
                    position='right center'
                    content={(50 - valueChange) + ' characters left'}
                    on='focus' />
            </LocaleField>
        }
        <div style={style.localeFieldFull}>
            <LocaleField label={t('description_prompt')} required>
                <Popup trigger={
                    <textarea
                        name='description'
                        style={style.descriptionTextarea}
                        value={data ? data.description : ''}
                        onChange={onChange}
                        onFocus={onChange}
                        maxLength='2000' />
                }
                    position='top right'
                    content={(2000 - valueChange) + ' characters left'}
                    on='focus' />
            </LocaleField>
        </div>
        <div style={style.localeFieldFull}>
            <LocaleField label={t('terms_url_prompt')}>
                <Popup trigger={
                    <Input fluid value={data ? data.termsUrl : ''}
                        name='termsUrl'
                        onChange={onChange}
                        onFocus={onChange}
                        maxLength='200' />
                }
                    position='right center'
                    content={(200 - valueChange) + ' characters left'}
                    on='focus' />
            </LocaleField>
        </div>
        <div style={style.localeFieldFull}>
            <LocaleField label={t('terms_prompt')}>
                <Popup trigger={
                    <textarea
                        name='terms'
                        style={style.termsTextarea}
                        value={data ? data.terms : ''}
                        onChange={onChange}
                        onFocus={onChange}
                        maxLength='4000' />
                }
                    position='top right'
                    content={(4000 - valueChange) + ' characters left'}
                    on='focus' />
            </LocaleField>
        </div>
        {update && isMaster && (
            <>
                <LocaleField label={t('brand_sku_prompt')}>
                    <Input fluid
                        name='brandKey'
                        value={brandKey}
                        onChange={onChangeBrandKey}
                        maxLength='50' />
                </LocaleField>
                <LocaleField label={t('reward_sku_prompt')}>
                    <Input fluid
                        name='sku'
                        value={sku}
                        onChange={onChangeSku}
                        maxLength='50' />
                </LocaleField>
            </>
        )}
    </div>
</div>
);

const localeHasContent = (locale) => Boolean(
    locale.title ||
    locale.description ||
    locale.brand ||
    locale.offer ||
    locale.template ||
    locale.terms ||
    locale.termsUrl
);

const EditRewardModalContainer = ({ t, dispatch, resourceScaler, reward, onClose, onRefresh}) => {
    const deleteModalRef = React.createRef();
    const [locale, setLocale] = useState('en')
    const [locales, setLocales] = useState({
        en: emptyLocale(),
        fr: emptyLocale(),
      })
      const [value, setValue] = useState('')
      const [resources, setResources] = useState('')
      const [levelReq, setLevelReqs] = useState(1)
      const [id, setId] = useState()
      const [asset, setAsset] = useState()
      const [sku, setSku] = useState('')
      const [brandKey, setBrandKey] = useState('')

      const [valueChange, setValueChange] = useState(0)

      const [category, setCategory] = useState()

      const [preferredLanguage, setPreferredLanguage] = useState()
      const [uploadPhotoProperty, setUploadPhotoProperty] = useState()
      const [hasCode, setHasCode] = useState(false)
      const [availableCodesCount, setAvailableCodesCount] = useState(null)
      const update = Boolean(id)
    const isMaster = localStorage.master === 'true'
    const isTangoCatalogReward = reward?.catalog === 'tango_card' || reward?.catalog === 'tango_card_v2'
    const isPublicCatalog = reward?.companyId == null && reward?.catalog
    const canEditReward = !isPublicCatalog || isMaster

    useEffect(() => {
        if (isPublicCatalog && !isMaster) {
            onClose && onClose();
        }
    }, [isPublicCatalog, isMaster, onClose])

    useEffect(() => {
        if (Boolean(reward && reward.id)) {
            setId(reward.id)
            setLocale(reward.locale)
            setValue(parseInt(reward.price/100))
            setResources(
                resourceScaler && reward.resources != null
                    ? reward.resources / resourceScaler
                    : reward.resources
            )
            setAsset(reward.asset)
            setLevelReqs(reward.levelReq)
            setLocales(locales => ({
                ...locales,
                ...reward.locales
            }))
            setCategory(reward.analyticsCategory)
            setHasCode(!!reward.hasCode)
            setSku(reward.sku || '')
            setBrandKey(reward.brandKey || '')
        } else {
            setHasCode(false)
            setSku('')
            setBrandKey('')
        }
    }, [reward, resourceScaler])

    useEffect(() => {
        if (!update || !id || !hasCode) {
            setAvailableCodesCount(null)
            return undefined
        }
        let cancelled = false
        DatabaseService.getAvailableRewardCodesCount({ rewardId: id })
            .then((r) => {
                if (!cancelled) setAvailableCodesCount(typeof r.count === 'number' ? r.count : null)
            })
            .catch(() => {
                if (!cancelled) setAvailableCodesCount(null)
            })
        return () => { cancelled = true }
    }, [update, id, hasCode])

    const trimLocales = (locales) => {
        var result = {};
        for(var key in locales) {
            if(preferredLanguage===key) {
                result[key] = locales[key];
            } else {
                var locale = locales[key];
                if(localeHasContent(locale)) {
                    result[key] = locales[key];
                }
            }
        }
        return result;
    }

    const onSubmit = (event) => {
        event && event.preventDefault();
        var method = update ? 'updateReward' : 'addReward';

        const trimmedLocales = trimLocales(locales)
        if (!isMaster) {
            Object.keys(trimmedLocales).forEach((key) => {
                if (trimmedLocales[key]) delete trimmedLocales[key].template
            })
        }

        var rewardPayload = {
            locale  : locale,
            locales : trimmedLocales,
            price   : value*100,
            asset   : asset,
            levelReq: levelReq || 1,
            resources : parseFloat(resources),
            analyticsCategory: category,
        }

        if (isMaster && update) {
            rewardPayload.sku = sku.trim() || null
            rewardPayload.brandKey = brandKey.trim() || null
        }

        dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:true});
        DatabaseService[method]({reward: rewardPayload, rewardId: id})
            .catch(error => {
                window.alert('An error occurred - check logs');
                console.error(error);
            })
            .then(()=>{
                onRefresh && onRefresh();
                onClose();
                dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:false});
            });
    }

    const onDelete = (deleteYes) => {
        if(deleteYes){
            dispatch({type:SET_LOADING_OVERLAY_ENABLE, enable:true});
            DatabaseService.removeReward({rewardId: id})
            .catch(error => {
                window.alert('An error occurred - check logs');
                console.error(error);
            })
            .then(result => {
                onRefresh();
                onClose();
                dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:false});
            })
        }
    }

    const isValid = () => {
        var selectedLocale = locales[locale];
        const valueNum = parseFloat(value);
        const resourcesNum = parseFloat(resources);
        return Boolean(selectedLocale) &&
                Boolean(selectedLocale.title) &&
                Boolean(selectedLocale.description) &&
                _.isFinite(valueNum) &&
                _.isFinite(resourcesNum) &&
                valueNum >= 0 &&
                resourcesNum >= 0;
    }

    const onChangePreferredLanguage = (event, {value}) => {
        setPreferredLanguage(value)
    }

    const onChangeCategory = (event, {value}) => {
        setCategory(value)
    }

    const onChangeValue = (event) => {
        var value = event.target.value;
        setValueChange(value.length)
        setValue(value)
    }

    const onChangeResources = (event) => {
        var value = event.target.value;
        setValueChange(value.length)
        setResources(value);
    }

    const onChangeSku = (event) => {
        setSku(event.target.value)
    }

    const onChangeBrandKey = (event) => {
        setBrandKey(event.target.value)
    }

    const onChangeLocales = (event, locale) => {
        var key = event.target.name;
        var value = event.target.value;
        setValueChange(value.length)
        setLocales(locales => {
            let newLocales = {...locales}
            newLocales[locale][key] = value
            return newLocales
        })
    }

    const onUploadPhoto = (propertyName) => {
        console.log('onUploadPhoto', propertyName);
        setUploadPhotoProperty(propertyName)
    }

    const onConfirmPhoto = (photo) => {
        setAsset(asset => {
            return {
                ...asset,
                dataUrl: photo
            }
        })
    }

    const canDelete = update && reward && reward.companyId != null && !isTangoCatalogReward

    if (!canEditReward) {
        return null;
    }

    return (
        <Modal open style={style.content} onClose={onClose} size='small'>
            <Modal.Header>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: spacings.small }}>
                    <span>{update ? t('updateincentive_modal_header') : t('addnewincentive_modal_header')}</span>
                    {update && id && (
                        <span style={{ fontSize: fontSizes.small, fontWeight: 'normal', marginLeft: 'auto' }}>
                            {t('rewardId')}: {id}
                        </span>
                    )}
                </div>
            </Modal.Header>
            <Modal.Content>
            <form onSubmit={onSubmit}>
                <Modal.Description>
                    <br />
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <div>{t('Primary Language')}</div>
                            <Dropdown options={languages}
                                    value={preferredLanguage}
                                    onChange={onChangePreferredLanguage}
                                    selection
                                    closeOnChange/>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <div>{t('Category')}</div>
                            <Dropdown options={categories}
                                    value={category}
                                    onChange={onChangeCategory}
                                    selection
                                    closeOnChange/>
                        </div>
                    </div>
                    <br />
                    <br />
                    <Tab panes={languages.map(language=>({
                        menuItem:language.text,
                        render:() =>
                            <RewardLocalePane t={t} 
                                locale={language.value}
                                data={locales[language.value]}
                                onChange={(event) => onChangeLocales(event, language.value)}
                                valueChange={valueChange}
                                update={update}
                                isMaster={isMaster}
                                brandKey={brandKey}
                                sku={sku}
                                onChangeBrandKey={onChangeBrandKey}
                                onChangeSku={onChangeSku}
                            />
                        }))}
                    />
                    <br />
                    <div sytle={style.columns}>
                        <div style={style.column}>
                            <div style={style.photoSection}>
                            <label style={style.localeLabel}>{t('photo_prompt')}*</label>
                            {Boolean(asset && (asset.url || asset.dataURL)) &&
                                <img style={style.imagePreview} src={asset.dataURL || asset.url} alt='' />
                            }
                            <Button type='button' 
                                    style={style.uploadButton} 
                                    onClick={()=>onUploadPhoto('asset.dataURL')}>
                                {t('Upload Image')}
                            </Button>
                            </div>
                        </div>
                        <div style={style.column}>
                            <label style={style.localeLabel}>{t('monetary_value_prompt')}*</label>
                            <Input name='value'
                                label={{ basic: true, content:'$'}} 
                                type='number' 
                                value={value} 
                                onChange={onChangeValue} /> 
                            <br />
                            <br />
                            <label style={style.localeLabel}>{t('reward_value_prompt')}*</label>
                            <Input name='resources' 
                                labelPosition='left'
                                type='number' value={resources} 
                                onChange={onChangeResources}>
                            <Label><i style={style.star} className="icon-Optimollar"/></Label>
                            <input />
                            </Input> 
                            <br />
                            <br />
                            {update && hasCode && id != null && (
                                <>
                                    <div style={{ fontSize: fontSizes.small }}>
                                        {t('unused_codes_available', { count: availableCodesCount != null ? availableCodesCount : '—' })}
                                    </div>
                                    <br />
                                    <br />
                                </>
                            )}

                            {resourceScaler &&
                            <div>
                                <div>{t('reward_scaled_value_prompt')}</div>
                                <Input
                                    labelPosition='left'
                                    type='number' value={resources * resourceScaler || ""} 
                                    >
                            <Label><i style={style.star} className="icon-Optimollar"/> x {resourceScaler}</Label>
                            <input disabled />
                            </Input> 
                            </div> }
                        </div>
                    </div>
                    <div style={style.modalActions}>
                        <DeletePromptContainer ref={deleteModalRef} onDeleteConfirmation = {onDelete} />
                        {update && canDelete &&
                            <Button style={buttons.delete} type='button' onClick={() => {deleteModalRef.current.showDeletePrompt()}}>{t('Delete')}</Button>            
                        }
                        <Button
                            type='submit'
                            style={update ? style.updateButton : style.saveButton}
                            disabled={!isValid()}>
                            {update ? t('Save') : t('Create')}
                        </Button>
                    </div>
                    {Boolean(uploadPhotoProperty) &&
                        <ChoosePhotoContainer
                            onConfirmPhoto={photo=>onConfirmPhoto(photo)}
                            onClose={onUploadPhoto}
                        />
                    }
                </Modal.Description>
            </form>
            </Modal.Content>
        </Modal>
    )
}

export default connect()(withTranslation('rewards')(EditRewardModalContainer));
